<h2 mat-dialog-title>
  <mat-icon style="margin-right: 0.5rem;">psychology</mat-icon>
  Schedule Analysis
</h2>

<form (ngSubmit)="analyzeSchedule()" #analysisForm="ngForm" autocomplete="off">
  <mat-dialog-content>
    <div *ngIf="!analysisResult && !loading" class="form-fields-vertical">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Ask a question about this schedule</mat-label>
        <textarea
          matInput
          name="question"
          [(ngModel)]="question"
          placeholder="e.g., Why isn't it scheduling? Why is team X assigned to field Y?"
          rows="3"
          maxlength="500"
          required>
        </textarea>
        <mat-hint>{{question.length}}/500</mat-hint>
      </mat-form-field>
    </div>

    <div *ngIf="loading" class="loading-section">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Analyzing schedule with AI...</p>
    </div>

    <div *ngIf="analysisResult && !loading" class="result-section">
      <div class="analysis-header">
        <div class="analysis-type-badge" [ngClass]="'type-' + analysisResult.analysisType">
          {{getAnalysisTypeLabel(analysisResult.analysisType)}}
        </div>
        <div class="question-display">
          <strong>Q:</strong> {{analysisResult.question}}
        </div>
      </div>

      <div class="key-findings" *ngIf="analysisResult.keyFindings.length > 0">
        <h4><mat-icon>lightbulb</mat-icon> Key Findings</h4>
        <ul>
          <li *ngFor="let finding of analysisResult.keyFindings">{{finding}}</li>
        </ul>
      </div>

      <div class="answer-section">
        <h4><mat-icon>smart_toy</mat-icon> Analysis</h4>
        <div class="markdown-content" [innerHTML]="getMarkdownHtml()"></div>
      </div>
    </div>

    <div *ngIf="error" class="error-section">
      <mat-icon class="error-icon">error</mat-icon>
      <p>{{error}}</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button" *ngIf="!loading">
      Cancel
    </button>
    
    <button 
      mat-flat-button 
      color="primary" 
      type="submit"
      [disabled]="!question.trim() || loading"
      *ngIf="!analysisResult">
      <mat-icon>psychology</mat-icon>
      Analyze
    </button>

    <button 
      mat-button 
      (click)="resetAnalysis()" 
      *ngIf="analysisResult && !loading">
      <mat-icon>refresh</mat-icon>
      Ask Another Question
    </button>
  </mat-dialog-actions>
</form>
